import { login, logout, getInfo } from "@/api/user";
import { getUserIdApi } from "@/api/auth-login";
import { getToken, setToken, removeToken, getUserName, setUserName, removeUserName } from "@/utils/auth";
// import router, { resetRouter } from "@/router";

const state = {
    token: getToken(),
    userName: getUserName()
};

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token;
    },
    SET_USERNAME: (state, userName) => {
        state.userName = userName;
    }
};

const actions = {
    login({ commit }, userInfo) {
        const comUscc = userInfo.comUscc;
        console.log(comUscc);
        return new Promise((resolve, reject) => {
            login(comUscc)
                .then((response) => {
                    const { data } = response;
                    if (data) {
                        commit("SET_TOKEN", data.id);
                        commit("SET_USERNAME", data.userName);
                        setToken(data.id);
                        setUserName(data.userName);
                    }
                    resolve(data);
                })
                .catch((error) => {
                    console.log(error);
                    reject(error);
                });
        });
    },
    // 统一认证登录
    authLogin({ commit }, userInfo) {
        // 从 sessionStorage 获取 Authorization
        const authorization = sessionStorage.getItem("Authorization");
        // 从 sessionStorage 获取 client-userInfo 并解析
        const clientUserInfoStr = sessionStorage.getItem("client-userInfo");
        let clientUserInfo = null;
        if (clientUserInfoStr) {
            try {
                clientUserInfo = JSON.parse(clientUserInfoStr);
            } catch (e) {
                console.error("解析 client-userInfo 失败:", e);
            }
        }
        
        // 使用 sessionStorage 中的值
        const username = clientUserInfo?.cn || "";
        const token = authorization || "";
        const phone = clientUserInfo?.idCardNumber || "";
        
        commit("SET_USERNAME", username);
        setUserName(username);
        commit("SET_TOKEN", token);
        setToken(token);
    },

    resetToken({ commit }) {
        return new Promise((resolve) => {
            commit("SET_TOKEN", "");
            commit("SET_USERNAME", "");
            sessionStorage.removeItem("client-userInfo");
            sessionStorage.removeItem("Authorization");
            localStorage.clear();
            sessionStorage.clear();
            removeToken();
            removeUserName();
            resolve();
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
